// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file api/v1/plan.proto (package api.v1, syntax proto3)
/* eslint-disable */

import type {
  GenFile,
  GenMessage,
  GenService,
} from "@bufbuild/protobuf/codegenv1";
import {
  fileDesc,
  messageDesc,
  serviceDesc,
} from "@bufbuild/protobuf/codegenv1";
import type { EmptySchema, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import {
  file_google_protobuf_empty,
  file_google_protobuf_field_mask,
  file_google_protobuf_timestamp,
} from "@bufbuild/protobuf/wkt";
import type { IDRequestSchema, PaginationMetadata } from "./common_pb";
import { file_api_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/plan.proto.
 */
export const file_api_v1_plan: GenFile =
  /*@__PURE__*/
  fileDesc(
    "ChFhcGkvdjEvcGxhbi5wcm90bxIGYXBpLnYxIqQBCgRQbGFuEgoKAmlkGAEgASgFEgwKBG5hbWUYAiABKAkSDgoGYW1vdW50GAMgASgBEhIKCnRpbWVfc3Rha2UYBCABKAUSLgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiMwoQTGlzdFBsYW5zUmVxdWVzdBIMCgRwYWdlGAEgASgFEhEKCXBhZ2Vfc2l6ZRgCIAEoBSJaChFMaXN0UGxhbnNSZXNwb25zZRIbCgVwbGFucxgBIAMoCzIMLmFwaS52MS5QbGFuEigKBG1ldGEYAiABKAsyGi5hcGkudjEuUGFnaW5hdGlvbk1ldGFkYXRhImAKEVVwZGF0ZVBsYW5SZXF1ZXN0EhoKBHBsYW4YASABKAsyDC5hcGkudjEuUGxhbhIvCgt1cGRhdGVfbWFzaxgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2sylQIKC1BsYW5TZXJ2aWNlEigKCkNyZWF0ZVBsYW4SDC5hcGkudjEuUGxhbhoMLmFwaS52MS5QbGFuEioKB0dldFBsYW4SES5hcGkudjEuSURSZXF1ZXN0GgwuYXBpLnYxLlBsYW4SQAoJTGlzdFBsYW5zEhguYXBpLnYxLkxpc3RQbGFuc1JlcXVlc3QaGS5hcGkudjEuTGlzdFBsYW5zUmVzcG9uc2USNQoKVXBkYXRlUGxhbhIZLmFwaS52MS5VcGRhdGVQbGFuUmVxdWVzdBoMLmFwaS52MS5QbGFuEjcKCkRlbGV0ZVBsYW4SES5hcGkudjEuSURSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5QhtaGWNhc2hicm9rZXIvZ2VuL2FwaS92MTthcGliBnByb3RvMw",
    [
      file_google_protobuf_empty,
      file_google_protobuf_timestamp,
      file_google_protobuf_field_mask,
      file_api_v1_common,
    ],
  );

/**
 * @generated from message api.v1.Plan
 */
export type Plan = Message<"api.v1.Plan"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: double amount = 3;
   */
  amount: number;

  /**
   * Em dias
   *
   * @generated from field: int32 time_stake = 4;
   */
  timeStake: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.Plan.
 * Use `create(PlanSchema)` to create a new message.
 */
export const PlanSchema: GenMessage<Plan> =
  /*@__PURE__*/
  messageDesc(file_api_v1_plan, 0);

/**
 * @generated from message api.v1.ListPlansRequest
 */
export type ListPlansRequest = Message<"api.v1.ListPlansRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message api.v1.ListPlansRequest.
 * Use `create(ListPlansRequestSchema)` to create a new message.
 */
export const ListPlansRequestSchema: GenMessage<ListPlansRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_plan, 1);

/**
 * @generated from message api.v1.ListPlansResponse
 */
export type ListPlansResponse = Message<"api.v1.ListPlansResponse"> & {
  /**
   * @generated from field: repeated api.v1.Plan plans = 1;
   */
  plans: Plan[];

  /**
   * @generated from field: api.v1.PaginationMetadata meta = 2;
   */
  meta?: PaginationMetadata;
};

/**
 * Describes the message api.v1.ListPlansResponse.
 * Use `create(ListPlansResponseSchema)` to create a new message.
 */
export const ListPlansResponseSchema: GenMessage<ListPlansResponse> =
  /*@__PURE__*/
  messageDesc(file_api_v1_plan, 2);

/**
 * @generated from message api.v1.UpdatePlanRequest
 */
export type UpdatePlanRequest = Message<"api.v1.UpdatePlanRequest"> & {
  /**
   * @generated from field: api.v1.Plan plan = 1;
   */
  plan?: Plan;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message api.v1.UpdatePlanRequest.
 * Use `create(UpdatePlanRequestSchema)` to create a new message.
 */
export const UpdatePlanRequestSchema: GenMessage<UpdatePlanRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_plan, 3);

/**
 * @generated from service api.v1.PlanService
 */
export const PlanService: GenService<{
  /**
   * @generated from rpc api.v1.PlanService.CreatePlan
   */
  createPlan: {
    methodKind: "unary";
    input: typeof PlanSchema;
    output: typeof PlanSchema;
  };
  /**
   * @generated from rpc api.v1.PlanService.GetPlan
   */
  getPlan: {
    methodKind: "unary";
    input: typeof IDRequestSchema;
    output: typeof PlanSchema;
  };
  /**
   * @generated from rpc api.v1.PlanService.ListPlans
   */
  listPlans: {
    methodKind: "unary";
    input: typeof ListPlansRequestSchema;
    output: typeof ListPlansResponseSchema;
  };
  /**
   * @generated from rpc api.v1.PlanService.UpdatePlan
   */
  updatePlan: {
    methodKind: "unary";
    input: typeof UpdatePlanRequestSchema;
    output: typeof PlanSchema;
  };
  /**
   * @generated from rpc api.v1.PlanService.DeletePlan
   */
  deletePlan: {
    methodKind: "unary";
    input: typeof IDRequestSchema;
    output: typeof EmptySchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_api_v1_plan, 0);
